import {
  Button,
  Center,
  Divider,
  Flex,
  IconButton,
  Img,
  Input,
  InputGroup,
  Link,
  Text,
  useBoolean,
  useBreakpointValue,
  useToast
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";

import { Input as InputForm } from "@/components/Input";
import { AuthContext, useAuth } from "@/contexts";
import Router from "next/router";
import { useContext, useEffect, useRef, useState } from "react";

type Inputs = {
  email: string;
  password: string;
};

interface CardLoginProps {
  checkout?: boolean;
  closeFn?: () => void;
  setWantLogin?: any;
  setWantRegister?: any;
  setWantCreate?: any;
}

export function CardLoginIdent({
  checkout,
  closeFn,
  setWantLogin,
  setWantRegister,
  setWantCreate
}: CardLoginProps) {
  const { handleSubmit, register } = useForm();
  const [ShowPassword, setShow] = useBoolean();
  const [email, setEmail] = useState(String);
  const [password, setPassword] = useState(String);
  const User = useAuth();
  const emailAutoCompleteRef = useRef<any>(null);

  const toast = useToast({
    position: "bottom",
    duration: 3000,
    isClosable: true
  });

  // useEffect(() => {
  //   setEmail(emailAutoCompleteRef.current.state.value);
  // }, [emailAutoCompleteRef, email]);

  const { signIn } = useContext(AuthContext);
  async function handleSignIn(data: Inputs) {
    signIn({ UserEmail: email, password })
      .then((response) => {
        if (response.status) {
          toast.closeAll();
          toast({
            title: "Login realizado com sucesso",
            status: "success",
            containerStyle: {
              color: "white",
              fontFamily: "arial",
              fontWeight: "100"
            },
            onCloseComplete: () => {
              if (Router.pathname === "/checkout/login" && checkout) {
                Router.push("/checkout/entrega");
                return;
              }
              if (Router.pathname === "/login") {
                Router.push("/minhaconta");
                return;
              } else if (Router.pathname === "/cadastro") {
                Router.push("/login");
                return;
              } else {
                Router.push(Router.pathname);
                return;
              }
            }
          });
        } else {
          toast.closeAll();
          toast({
            title: "Erro ao realizar login",
            status: "error",
            description: response.message
          });
        }
      })
      .catch((error) => {
        toast.closeAll();
        toast({
          title: "Erro ao realizar login",
          status: "error",
          description: error.message
        });
      });
  }

  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex as="form" mt={"20px"} justify="center" onSubmit={handleSubmit(handleSignIn)}>
      <Flex direction="column" alignItems="center" w={["full", "400px"]} gap={"10px"}>
        <Input
          placeholder="E-mail"
          type="email"
          w={["full", "400px"]}
          mb="5px"
          fontWeight={"500"}
          bgColor={"ll-gray.600"}
          fontSize={"text1"}
          border="1px solid"
          borderColor="ll-gray.100"
          borderRadius={"50px"}
          _placeholder={{ color: "gray.300" }}
          _hover={{ border: "1px solid #0C4EA2" }}
          _focus={{
            boxShadow: "none"
          }}
          {...register("email", {
            value: email,
            onChange: (e) => setEmail(e.target.value)
          })}
        />
        <Flex
          w={"full"}
          bgColor={"#E8F0FE"}
          border="1px solid"
          borderColor="ll-gray.100"
          borderRadius={"50px"}
        >
          <Input
            w={["full", "full"]}
            fontWeight={"500"}
            borderLeftRadius={"50px"}
            _placeholder={{ color: "gray.300" }}
            _hover={{ border: "1px solid #0C4EA2" }}
            _focus={{
              boxShadow: "none"
            }}
            fontSize={"text1"}
            height={"40px"}
            placeholder="Senha"
            bgColor={"ll-gray.600"}
            type={ShowPassword ? "text" : "password"}
            {...register("password", {
              value: password,
              onChange: (e) => setPassword(e.target.value)
            })}
          />
          <Img
            mx={["10px", "10px"]}
            w={["25px", "25px"]}
            alt={"Alternative to Image"}
            cursor={"pointer"}
            src={
              ShowPassword
                ? "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/password-hidden.svg"
                : "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/password-nohidden.svg"
            }
            onClick={setShow.toggle}
            _focus={{ border: "none" }}
          />
        </Flex>

        <Button variant={"primary-button"} _hover={{ opacity: "0.5" }} type="submit" w="full">
          ENTRAR
        </Button>
        <Flex w={"full"} justifyContent={isWideVersion ? "center" : "flex-start"}>
          <Link
            mt={["0px", "5px"]}
            color={"#1E64C3"}
            fontSize={"text1"}
            textStyle={"Regular"}
            onClick={() => {
              setWantCreate(false);
              setWantLogin(false);
              setWantRegister(true);
            }}
          >
            Esqueci minha senha
          </Link>
        </Flex>

        <Center gap={"15px"}>
          <Divider
            w={["125px", "170px"]}
            colorScheme={"blackAlpha"}
            border={"1px dashed "}
            borderColor={"#A9A9A9"}
          />
          <Text my=".5rem">ou </Text>
          <Divider
            w={["125px", "165px"]}
            colorScheme={"blackAlpha"}
            border={"1px dashed "}
            borderColor={"#A9A9A9"}
          />
        </Center>

        <Button
          variant={"secondary-button"}
          bgColor={"ll-blue.main"}
          color={"ll-white.main"}
          _hover={{ opacity: "0.5" }}
          w="full"
          onClick={() => {
            setWantCreate(true);
            setWantLogin(false);
            setWantRegister(false);
          }}
          // onClick={() => Router.push("/recuperar-senha/enviar-email")}
        >
          CADASTRE-SE
        </Button>
      </Flex>
    </Flex>
  );
}
